export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Clínica Médica - Medicina Interna',
      professionals: [
        { name: 'Dr. Pablo Corral', specialty: 'Lipidología y Trastornos del Colesterol, Lípidos y Prevención Cardiovascular' },
        { name: 'Dr. Leonardo Bufi', specialty: 'Especialista en Obesidad' }
      ],
      description: 'Atención integral del adulto, diagnóstico y tratamiento de enfermedades complejas, seguimiento de patologías crónicas.',
      color: 'blue'
    },
    {
      icon: 'ri-capsule-line',
      title: 'Gastroenterología',
      professionals: [
        { name: 'Dra. Victoria Sayanes', specialty: '' }
      ],
      description: 'Diagnóstico y tratamiento de enfermedades del sistema digestivo, estudios endoscópicos y seguimiento especializado.',
      color: 'blue'
    },
    {
      icon: 'ri-virus-line',
      title: 'Infectología',
      professionals: [
        { name: 'Dr. Gonzalo Corral', specialty: '' }
      ],
      description: 'Prevención, diagnóstico y tratamiento de enfermedades infecciosas, control de infecciones y asesoramiento médico.',
      color: 'blue'
    },
    {
      icon: 'ri-scan-line',
      title: 'Diagnóstico por Imágenes - Ecografía',
      professionals: [
        { name: 'Dra. Estela Di Nella', specialty: '' }
      ],
      description: 'Estudios ecográficos de alta precisión para diagnóstico médico, con equipamiento de última generación.',
      color: 'blue'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Especialidades Médicas
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Contamos con un equipo de profesionales especializados para brindarte la mejor atención médica
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-10 border border-blue-100"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${service.icon} text-3xl text-blue-600`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-blue-900 mb-3">
                    {service.title}
                  </h3>
                  <div className="mb-4">
                    {service.professionals.map((prof, idx) => (
                      <div key={idx} className="mb-3">
                        <div className="flex items-center gap-2 mb-1">
                          <i className="ri-user-line text-sm text-blue-600"></i>
                          <p className="text-sm font-semibold text-blue-800">{prof.name}</p>
                        </div>
                        {prof.specialty && (
                          <p className="text-xs text-gray-600 ml-5">{prof.specialty}</p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-600 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            ¿Necesitás un turno?
          </h3>
          <p className="text-base text-blue-100 mb-8 max-w-2xl mx-auto">
            Contactanos por teléfono o WhatsApp para coordinar tu consulta médica
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+542234515475" 
              className="inline-flex items-center justify-center gap-2 bg-white text-blue-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              0223 451-5475
            </a>
            <a 
              href="https://wa.me/5492235470285" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              223-547-0285
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}